import { useState, useEffect } from "react";
import axios from "axios";
import { X, CheckCircle, Warning, User, Clock } from "@phosphor-icons/react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const overlay = {
  position: "fixed", inset: 0, background: "rgba(15,23,42,0.55)", backdropFilter: "blur(3px)",
  display: "flex", alignItems: "center", justifyContent: "center", zIndex: 10000, padding: 16,
};

export default function PodViewerModal({ trackingCode, onClose }) {
  const [pod, setPod] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    let active = true;
    (async () => {
      const token = localStorage.getItem("blumove_token");
      try {
        const r = await axios.get(`${API}/shipments/${trackingCode}/proof-of-delivery`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (active) setPod(r.data.pod);
      } catch (e) {
        if (active) setError(e?.response?.data?.detail || "Prova de entrega indisponivel.");
      } finally {
        if (active) setLoading(false);
      }
    })();
    return () => { active = false; };
  }, [trackingCode]);

  return (
    <div style={overlay} onClick={onClose} data-testid="pod-viewer-modal">
      <div
        onClick={(e) => e.stopPropagation()}
        className="animate-fade-in-up"
        style={{ background: "var(--surface)", borderRadius: 18, width: "100%", maxWidth: 440, maxHeight: "92vh", overflowY: "auto", boxShadow: "0 20px 60px rgba(0,0,0,0.25)" }}
      >
        <div className="flex items-center justify-between" style={{ padding: "16px 20px", borderBottom: "1px solid var(--border-color)" }}>
          <div className="flex items-center gap-2">
            <CheckCircle size={20} weight="fill" style={{ color: "var(--success)" }} />
            <h3 style={{ fontFamily: "Outfit", fontWeight: 700, fontSize: "1.05rem" }}>Prova de entrega</h3>
          </div>
          <button onClick={onClose} style={{ background: "none", border: "none", cursor: "pointer", color: "var(--text-muted)" }} aria-label="Fechar">
            <X size={22} />
          </button>
        </div>

        <div style={{ padding: 20 }}>
          {loading ? (
            <p style={{ color: "var(--text-muted)", fontSize: "0.88rem", textAlign: "center", padding: "20px 0" }}>A carregar...</p>
          ) : error ? (
            <div className="flex items-center gap-2" style={{ background: "rgba(220,38,38,0.08)", color: "#dc2626", padding: "10px 12px", borderRadius: 10, fontSize: "0.82rem" }}>
              <Warning size={16} weight="fill" /> {error}
            </div>
          ) : pod ? (
            <>
              <span className="overline" style={{ display: "block", marginBottom: 6 }}>Foto da entrega</span>
              {pod.photo_base64 && (
                <img src={pod.photo_base64} alt="Prova de entrega" style={{ width: "100%", borderRadius: 12, marginBottom: 16, border: "1px solid var(--border-color)" }} />
              )}

              <span className="overline" style={{ display: "block", marginBottom: 6 }}>Assinatura</span>
              {pod.signature_base64 && (
                <img src={pod.signature_base64} alt="Assinatura" style={{ width: "100%", height: 120, objectFit: "contain", borderRadius: 12, marginBottom: 16, border: "1px solid var(--border-color)", background: "#fff" }} />
              )}

              <div className="flex items-center gap-2" style={{ padding: "10px 12px", borderRadius: 10, background: "var(--bg)", marginBottom: 8 }}>
                <User size={16} weight="duotone" style={{ color: "var(--primary)" }} />
                <span style={{ fontSize: "0.85rem" }}>Recebido por <strong>{pod.recipient_name}</strong></span>
              </div>
              <div className="flex items-center gap-2" style={{ padding: "10px 12px", borderRadius: 10, background: "var(--bg)" }}>
                <Clock size={16} weight="duotone" style={{ color: "var(--primary)" }} />
                <span style={{ fontSize: "0.85rem" }}>
                  {new Date(pod.delivered_at).toLocaleString("pt-PT", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" })}
                  {pod.delivered_by ? ` · ${pod.delivered_by}` : ""}
                </span>
              </div>
            </>
          ) : null}
        </div>
      </div>
    </div>
  );
}
